import { render, staticRenderFns } from "./AvailabilityRules.vue?vue&type=template&id=13a85d22&"
import script from "./AvailabilityRules.vue?vue&type=script&lang=js&"
export * from "./AvailabilityRules.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityRules.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports